module.exports = __webpack_public_path__ + "img/undraw_Ride_a_bicycle_re_6tjy.d2346ee2.png";